import React from 'react'
import SubSectionView from './SubSectionView';
import { makeStyles, Divider, Typography, Tooltip } from "@material-ui/core";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import Helper from '../../../common/Helper';


const useStyles = makeStyles((theme) => ({
    listSecondaryText: {
        fontSize: '0.65rem',
        lineHeight: '1',
        letterSpacing: 'normal',
    },

}));


const SectionView = ({ section, handleClick, item, onSectionContentShowClick, activeSubId, completedSecIds, completedSubIds, curriculumFlow, isFishish, handleViewDocument, seqNo }) => {
    const classes = useStyles();

    return (
        <>
            <ListItem role={undefined} dense button onClick={() => handleClick(item.sectionID)} disabled={isFishish}>
                <ListItemIcon>
                    <Checkbox
                        size="small"
                        edge="start"
                        tabIndex={-1}
                        disableRipple
                        checked={curriculumFlow.filter(x => x.sectionId == item.sectionID).map(y => y.completed).every(x => x == true)}
                    />
                </ListItemIcon>
                <ListItemText primary={<Tooltip title={item.sectionName}><Typography variant="subtitle2" >{`Section ${seqNo}: ${item.sectionName}`}</Typography></Tooltip>} secondary={<Typography variant="caption" className={classes.listSecondaryText}>{Helper.stripHtmlTags(item?.shortDescription)}</Typography>} />
                {section.includes(item.sectionID) ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Divider />
            <Collapse in={section.includes(item.sectionID)} timeout="auto" unmountOnExit>
                <List component="div" disablePadding dense style={{ paddingLeft: '16px' }}>
                    {item.subSections.map((subitem, i) => {
                        //if (subitem.hasChildren == true) {
                        //     return <SectionView section={section} completedSecIds={completedSecIds} completedSubIds={completedSubIds} handleClick={handleClick}  onSectionContentShowClick={onSectionContentShowClick}/>
                        // } else {
                        return <SubSectionView sectionId={item.sectionID} isComplete={curriculumFlow.find(x => x.sectionId == item.sectionID && x.subSectionId == subitem.sectionID)?.['completed']} completedSubIds={completedSubIds} activeSubId={activeSubId} disabled={curriculumFlow.find(x => x.sectionId == item.sectionID && x.subSectionId == subitem.sectionID)?.['disabled'] || isFishish} item={subitem} onSectionContentShowClick={onSectionContentShowClick} handleViewDocument={handleViewDocument} />
                        //  }
                    })}
                </List>
            </Collapse>
            <Divider />
        </>
    )
}

export default SectionView